import { render, staticRenderFns } from "./Sanierungen.vue?vue&type=template&id=95f70728&"
import script from "./Sanierungen.vue?vue&type=script&lang=js&"
export * from "./Sanierungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports